<template>
	<div class="flex-column">
		<div class="full-height overflow-y-auto pb-50 mb-10">
			<div>
				<label class="h6 display-block">
					아이디
					<input v-model="item.member_id" class="input-box radius-10 width-100 mt-10" placeholder="아이디를 입력하세요" maxlength="50" lang="ko" disabled/>
				</label>

				<label class="h6 display-block mt-10">
					이름
					<input v-model="item.member_name" class="input-box radius-10 width-100 mt-10" placeholder="이름을 입력하세요" maxlength="20" lang="ko"/>
				</label>

				<label class="h6 display-block mt-10">
					구분
					<select
						v-model="item.member_level"
						class="input-box radius-10 width-100 mt-10"
					>
						<option value="">선택하세요</option>
						<template
							v-for="(grade, g_index) in codes.M001.items"
						>
							<option
								v-if="grade.sub_code != '000' && grade.code_index < 3"
								:key="'grade_' + g_index"
								:value="grade.code_index"
							>{{ grade.code_name }}</option>
						</template>
					</select>
				</label>

				<label class="h6 display-block mt-10">
					연락처
					<input v-model="item.member_tell" class="input-box radius-10 width-100 mt-10" placeholder="연락처를 입력하세요" maxlength="20" lang="ko"/>
				</label>

				<label class="h6 display-block mt-10">
					메모
					<textarea
						v-model="item.member_memo"
						class="input-box radius-10 width-100 mt-10"
						placeholder="메모를 입력하세요"
						lang="ko">
					</textarea>
				</label>
			</div>

		</div>
		<div
			v-if="user.member_level >= 3"
			class="mt-auto"
		>
			<button
				class="btn-full btn-primary"
				@click="putMember"
			>저장</button>
		</div>
	</div>
</template>

<script>

export default {
	name: 'MemberView'
	, components: {}
	, props: ['user', 'codes']
	, data: function(){
		return {
			program: {
				name: '현장 인원 상세 정보'
				, not_top: true
				, title: true
				, bottom: false
				, is_container: true
			}
			, item: {
				project_content: ''
			}
			, member_idx: this.$route.params.idx
		}
	}
	, methods: {
		getData: async function(){
			this.$bus.$emit('on', true)
			try {
				const result = await this.$request.init({
					method: 'get'
					, url: 'projectmember/getMemberInfo'
					, data: {
						idx: this.member_idx
					}
				})

				if(result.success){
					this.item = result.data.member_info
				}else{
					throw result.message
				}
			}catch (e){
				this.$bus.$emit('notify', { type: 'error', message: e})
			}finally {
				this.$bus.$emit('on', false)
			}
		}
		, putMember: async function(){
			this.$bus.$emit('on', true)
			try {

				const result = await this.$request.init({
					method: 'post'
					, url: 'projectmember/putMember'
					, data: this.item
				})

				if(result.success){
					this.$bus.$emit('notify', { type: 'success', message: result.message})
				}else{
					throw result.message
				}
			}catch (e){
				this.$bus.$emit('notify', { type: 'error', message: e})
			}finally {
				this.$bus.$emit('on', false)
			}
		}
	}
	, created() {
		this.$bus.$emit('onLoad', this.program)
		this.getData()
	}
}
</script>